export const ReadWrite = 'readwrite'
